import { providentFundsMiddleware } from './provident-funds-middleware';

export const providentFundsMiddlewares = [providentFundsMiddleware];
